import { useLang } from "@/context/LangContext";
import { COPY } from "@/components/landing/landingCopy";
import { Header } from "@/components/landing/landingPrimitives";
import OurStoryBody from "@/components/landing/OurStoryBody";

// Public Our Story marketing page. Composed as: shared PublicHeader
// (with Our Story set active) + OurStoryBody. Bilingual copy lives
// inside OurStoryBody. Only English is authored in this pass;
// Spanish translation lands in a later authorized pass.
export default function OurStory() {
  const { lang, setLang } = useLang();
  const c = COPY[lang] || COPY.en;
  return (
    <div className="min-h-screen bg-white" data-testid="our-story-root">
      <Header c={c} lang={lang} setLang={setLang} activePage="story" />
      <OurStoryBody lang={lang} />
    </div>
  );
}
